<template>
  <div class="pageWarp">
    <!-- 标题 -->
    <Title-Box :top-title="topTitle"></Title-Box>

    <!-- 黄色提示栏 -->
<!--    <div :class="{'hide': hideTopYellowTips}" class="yellow_tips_box boxs flex_h_hL_vC">-->
<!--      <span class="info">如2999的设备，用户参与直降活动后仅需1999元。即直降款=2999-1999=1000元</span>-->
<!--      <img @click="hideTopYellowTips = true" class="icon_close_yellow"-->
<!--           src="@/assets/images/enjoy/yellowCloseIcon.png" alt="">-->
<!--    </div>-->

    <div class="package-top">
      <span class="top_ri flex_h_hR_vC">
        <button class="butStyle pinkBtn exportBtn" @click="tableExport">
          <i class="exportIcon"></i>
          <span>导出当前范围数据</span>
        </button>

        <button style="margin-left: 20px" class="butStyle pinkBtn exportBtn" @click="tableExportAll">
          <i class="exportIcon"></i>
          <span>导出全部数据</span>
        </button>
      </span>
    </div>  
    <!-- 日期、月份筛选区 -->
    <div class="filter_box boxs flex_h_hL_vC">
      <div class="left_picker boxs flex_h ite-c">
        <el-date-picker
                v-model="dateValue"
                type="date"
                placeholder="选择年月日"
                value-format="yyyyMMdd"
                :clearable="false"
                @change="onDateChange"
        >
        </el-date-picker>
      </div>
    </div>

    <!-- 筛选框 -->
    <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
      <template slot="otherCom">

        <el-form-item>
          <el-input
                  v-model="searchForm.params.orderId"
                  placeholder="请输入订单号"
                  @keyup.enter.native="handleSearch"
                  maxlength="25" size="medium" clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-select v-model="searchForm.params.memberId"
                     @change="handleSearch"
                     placeholder="请选择终端归属"
                     size="medium" clearable
                     filterable>
            <el-option
                    v-for="item in terminalOwnershipOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 1215增加支付状态 -->
        <el-form-item>
          <el-select v-model="searchForm.params.status"
                     @change="handleSearch"
                     placeholder="请选择支付状态"
                     size="medium" clearable
                     filterable>
            <el-option
                    v-for="item in payStatus"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        
        <el-form-item>
          <el-select v-model="searchForm.params.payerId"
                     @change="handleSearch"
                     placeholder="请选择垫资方名称"
                     size="medium" clearable
                     filterable>
            <el-option
                    v-for="item in advanceMoneyPlatformOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>


        <el-form-item>
          <el-select
                  :value="searchForm.params.status"
                  @change="onStatusChange"
                  placeholder="请选择垫资状态"
                  size="medium" clearable
                  filterable>
            <el-option
                    v-for="item in statusOptions"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>

      </template>
    </sr-filter>

    <div class="summary_area boxs flex_h">
      <!-- 左边统计 -->
      <div class="left_simple_block summary_block boxs flex_h_hC_vC">
        <span class="clamp_1">共查询到 {{tableData.length}} 笔</span>
      </div>

      <div class="summary_block boxs flex_v_hL_vC">
        <div class="first_text flex_h_hS_vC">
          <span>应垫资金额</span>
          <span><small>{{stat.dueCount}}</small>笔</span>
        </div>
        <div class="second_text clamp_1 flex_h ite-fe">
          <span class="bigT">{{stat.dueAmount | centsToYuan}}</span> 元
        </div>
      </div>

      <div class="summary_block boxs flex_v_hL_vC">
        <div class="first_text flex_h_hS_vC">
          <span>实垫资金额</span>
          <span><small>{{stat.actualCount}}</small>笔</span>
        </div>
        <div class="second_text clamp_1 flex_h ite-fe">
          <span class="bigT">{{stat.actualAmount | centsToYuan}}</span> 元
        </div>
      </div>

      <div class="summary_block boxs flex_v_hL_vC">
        <div class="first_text flex_h_hS_vC">
          <span>待核销金额</span>
          <span><small>{{stat.stayCount}}</small>笔</span>
        </div>
        <div class="second_text clamp_1 flex_h ite-fe">
          <span class="bigT">{{stat.stayAmount | centsToYuan}}</span> 元
        </div>
      </div>
    </div>


    <!-- 表格 -->
    <div class="botTable boxs tableTheadGray">
      <div class="tableTop">
        <span class="top_le">直降款列表</span>

        <div class="btnGroup">
          <!-- <button class="butStyle pinkBtn exportBtn" @click="tableExport">
            <i class="exportIcon"></i>
            <span>导出当前范围数据</span>
          </button>

          <button style="margin-left: 20px" class="butStyle pinkBtn exportBtn" @click="tableExportAll">
            <i class="exportIcon"></i>
            <span>导出全部数据</span>
          </button> -->
          <button class="butStyle pinkBtn exportBtn exportBtn1" :disabled="errhotSellStatus == '正常'?false:true" :class="{exportBtn2:errhotSellStatus == '正常'&& tableData != ''}" @click="showImportDialog1">
            <i class="exportIcon"></i>
            <span>导入支付单</span>
          </button>
          <button class="butStyle pinkBtn exportBtn exportBtn2" :disabled="tableData == ''?true:false" :class="{exportBtn3:tableData == ''}" @click="showImportDialog">
            <i class="exportIcon"></i>
            <span>导入对账单</span>
          </button>
        </div>
      </div>
      <el-table :data="tableData"
                size="small"
                style="width: 100%;"
                border
                fit
                highlight-current-row
                tooltip-effect="dark"
      >
        <!-- 1215新增这是列表前面的多选框 -->
        <!-- <el-table-column type="selection" align="center" width="40"></el-table-column> -->
        <el-table-column label="订单号" prop="orderId" min-width="12" header-align="center" align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="blueT">{{scope.row.orderId}}</span>
          </template>
        </el-table-column>
        <el-table-column label="终端归属" prop="storeName" min-width="12" header-align="center" align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column label="权益直降款（元）" prop="straightDownMoney" width="70" header-align="center" align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="orangeT">{{scope.row.straightDownMoney | centsToYuan}}</span>
          </template>
        </el-table-column>
        <el-table-column label="垫资方名称" prop="payerName" min-width="12" header-align="center" align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column label="应垫资金额(元)" prop="dueAmount" min-width="12" header-align="center" align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="orangeT">{{scope.row.dueAmount | centsToYuan}}</span>
          </template>
        </el-table-column>
        <el-table-column label="垫资状态" prop="status" min-width="12" header-align="center" align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <!--            {{scope.row.status.value}}-->
            <span :class="getStatusText(scope.row.status.value).cls">{{scope.row.status.text}}</span>
          </template>
        </el-table-column>
        <el-table-column label="实垫资金额（元）" prop="actualAmount" min-width="12" header-align="center" align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="orangeT">{{scope.row.actualAmount | centsToYuan}}</span>
          </template>
        </el-table-column>
        <!-- 1215新增核销状态 -->
        <el-table-column label="核销状态" prop="hotSellStatus" min-width="12" header-align="center" align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span :class="[{greenT:scope.row.hotSellStatus != undefined &&  scope.row.hotSellStatus.text == '正常'},{orangeT:scope.row.hotSellStatus != undefined && scope.row.hotSellStatus.text=='异常'}]">{{scope.row.hotSellStatus !=undefined ?scope.row.hotSellStatus.text:''}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" min-width="12" header-align="center" align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button @click="goDetailPage(scope)"
                       class="greenT"
                       icon="el-icon-search"
                       type="text"
                       title="详情">详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBox boxs">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="searchForm.current" :page-sizes="[10, 20, 30]" :page-size="searchForm.size"
                       layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 导入弹窗-start -->
    <el-dialog width="400px" :title="dialogMap[dialogTitle]" :visible.sync="dialogFormVisible" @close="closeDialog"
               :before-close="beforeClose" :close-on-click-modal=false :show-close="true">
      <el-form ref="form" :rules="rules" :model="postForm" label-width="92px" style="position:relative;">
        <el-row>
          <el-col :span="24">
            <el-form-item label="上传文件：" prop="fieldId">
              <el-upload
                      action=""
                      :show-file-list="false"
                      :before-upload="beforeUpload"
                      :on-success="handleUploadSuccess"
                      :on-error="handleUploadError"
                      accept=".xls,.xlsx"
                      :http-request="onUpload"
              >
                <template>
                  <el-button size="small" class="uploadBtn">
                    <span>请上传文件</span>
                    <i class="el-icon-upload el-icon--right"></i>
                  </el-button>
                  <span slot="tip" class="uploadTip">只能上传excel式文件</span>
                </template>
              </el-upload>
              <a @click="downloadTemplate" class="uploadTemplate">点击下载模板</a>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer flex-col">
                <div class="flex-row jus-c">
                    <button @click="beforeClose" class="butStyle cancelBtn">退 出</button>
                </div>
            </span>
    </el-dialog>
    <el-dialog width="400px" :title="dialogMap[dialogTitle]" :visible.sync="dialogFormVisible1" @close="closeDialog"
               :before-close="beforeClose" :close-on-click-modal=false :show-close="true">
      <el-form ref="form" :rules="rules" :model="postForm" label-width="92px" style="position:relative;">
        <el-row>
          <el-col :span="24">
            <el-form-item label="上传文件：" prop="fieldId">
              <el-upload
                      action=""
                      :show-file-list="false"
                      :before-upload="beforeUpload"
                      :on-success="handleUploadSuccess"
                      :on-error="handleUploadError"
                      accept=".xls,.xlsx"
                      :http-request="onUpload1"
              >
                <template>
                  <el-button size="small" class="uploadBtn">
                    <span>请上传文件</span>
                    <i class="el-icon-upload el-icon--right"></i>
                  </el-button>
                  <span slot="tip" class="uploadTip">只能上传excel式文件</span>
                </template>
              </el-upload>
              <a @click="downloadTemplate" class="uploadTemplate">点击下载模板</a>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer flex-col">
                <div class="flex-row jus-c">
                    <button @click="beforeClose" class="butStyle cancelBtn">退 出</button>
                </div>
            </span>
    </el-dialog>
    <!-- 导入弹窗-end -->
  </div>
</template>

<script>
  import TitleBox from '@/components/Common/TitleBox/TitleBox.1';
  import SrFilter from '@/components/Common/Filter/Filter';
  import {formatDate} from '@/utils/dateFormatter';
  import {getListAPI, getStatAPI, getAdvancePlayerAPI, getStoresAPI,importAccountStatement,uploadPaymentForm} from '@/api/ReducedFeeManage/reducedFeeManage';
  import {objectToQueryString} from '@/utils/commonUtils.js';

  const status = {
    '-1': {text: '申请中', cls: 'grayT'},
    '0': {text: '待核销', cls: 'orangeT'},
    '1': {text: '未支付', cls: 'grayT'},
    '2': {text: '已支付', cls: 'lightGT'},
  }
  //1215新增核销状态
  const hotSellStatus = {
    '0': {text: '异常'},
    '1': {text: '正常'},
  }
  // const hotSellStatus = [
  //   {text: "正常",value: 1}
  // ]
  // 搜索表格的条件-筛选栏
  const defaultSelectMenu = {
    name: '无',
    id: '0',
  }
  // 弹窗的数据
  const defaultPostForm = {
    name: null, //菜单名称
    path: null, // 菜单路由
    pid: null,
    icon: null
  }
  //获取当前日期
  let getCurrDay = function () {
    let date = new Date();
    return formatDate(date, 'yyyyMMdd');
  }

  // 搜索表格的条件
  const searchConst = {
    current: 1, //当前页码
    size: 10, //每页条数
    params: {
      date: getCurrDay(), //日期
      orderId: null, //订单号
      memberId: null, //终端归属
      payerId: null, //垫资方id
      status: null, //垫资状态
    },
  }

  export default {
    data() {
      return {
        dateValue: new Date(),
        //标题
        topTitle: {
          title: '直降款管理',
          subTit: ''
        },
        // 弹窗数据
        postForm: Object.assign({}, defaultPostForm),
        deleteMenuDialogVisible: false,
        // 添加/编辑窗口是否显示
        dialogFormVisible: false,
        dialogFormVisible1: false,
        // 弹窗标题
        dialogMap: {
          add: '添加会员',
          edit: '编辑会员'
        },
        dialogTitle: '',
        // 筛选数据-日期
        filterData: [],

        // 是否隐藏页面顶部提示信息
        hideTopYellowTips: false,

        // 表格搜索条件
        searchForm: this.initSearchParams(),
        // 终端归属
        terminalOwnershipOptions: [],
        // 垫资方id
        advanceMoneyPlatformOptions: [],
        //1215支付状态
        payStatus:[],
        // 垫资状态
        statusOptions: [
          {key: 0, label: '待核销'},
          {key: 1, label: '未支付'},
          {key: 2, label: '已支付'},
        ],
        // 表格数据
        tableData: [],
        // 表格数据总数
        total: 0,
        // 日期时间选择器
        timePickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          }
        },
        // 弹窗校验规则
        rules: {
          name: [{required: true, message: '请输入会员名称', trigger: 'blur'}],
        },
        stat: {},
        uploadFile:'',
        getHotSellStatus:'',
        // 存储异常数据
        errData:[],
        errhotSellStatus:''
      }
    },
    computed: {},
    components: {
      TitleBox,
      SrFilter,
    },
    created() {
      this.getFilterData()
      this.loadList()
      this.getStat()
      this.loadStores()
      this.loadAdvancePlayers()
      this.initSearchParams()
    },
    methods: {
      initSearchParams() {
        return this.$deepClone(searchConst);
      },
      async loadAdvancePlayers() {
        const {data} = await getStoresAPI()
        this.terminalOwnershipOptions = data;
      },
      async loadStores() {
        const {data} = await getAdvancePlayerAPI()
        this.advanceMoneyPlatformOptions = data
      },
      getStatusText(val) {
        return status[val] || {text: '未知', cls: 'grayT'}
      },
      onDateChange(value) {
        //0107
        this.errhotSellStatus =''
        if (!value) {
          this.searchForm.params.date = value || null
        }
        this.searchForm.params.date = value
        this.handleSearch()
      },
      onStatusChange(value) {
        this.searchForm.params.status = value
        if (value == null || value == 'undefined' || value === '') {
          console.log(this.searchForm.params.status);
          this.searchForm.params.status = null
        }
        this.handleSearch()
      },
      tableExportAll() {
        const url = `${this.$baseNewUrl}esaleb-service-tbs/reduced-fee/exportall?accessToken=${this.$accessToken()}`;
        window.open(url, '_blank');
      },
      selsChange(sels) {
        this.sels = sels
        console.log('this.sels',this.sels);
      },
      //1217导出
      // tableExport() {    
      //   if(this.sels== undefined || this.sels== ''){
      //     const url = `${this.$baseNewUrl}esaleb-service-tbs/reduced-fee/exportall?accessToken=${this.$accessToken()}&${objectToQueryString(this.searchForm.params)}`;
      //   window.open(url, '_blank');
      //   }else{
      //     let ids = this.sels.map((item) => item.id).join()
      //     console.log('id',ids);
      //      const url = `${this.$baseNewUrl}esaleb-service-tbs/reduced-fee/exportall?accessToken=${this.$accessToken()}`;
      //     window.open(url, '_blank');
      //   }      
      // },
      tableExport() {
        const url = `${this.$baseNewUrl}esaleb-service-tbs/reduced-fee/exportall?accessToken=${this.$accessToken()}&${objectToQueryString(this.searchForm.params)}`;
        window.open(url, '_blank');
      },
      // 弹窗关闭前
      beforeClose() {
        this.resetData()
      },
      // 弹出导入弹窗
      showImportDialog() {
        this.dialogTitle = 'import'
        this.dialogFormVisible = true
      },
      showImportDialog1() {
        this.dialogTitle = 'import'
        this.dialogFormVisible1 = true
      },
      showDeleteDialog(data) {
        console.log(data)
        this.deleteMenuDialogVisible = true
        // 获取区域树数据
        this.postForm = JSON.parse(JSON.stringify(data.row))
        
        this.selectedRow = {
          index: data.$index,
          id: data.row.id
        }
      },
      // 重置表单
      resetData() {
        this.dialogFormVisible = false
        this.dialogFormVisible1 = false
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
        this.postForm = Object.assign({}, defaultPostForm)
        this.selectedRow = Object.assign({}, defaultSelectMenu)
      },
      // 下载话费导入模板
      async downloadTemplate() {
        try {
          const url = `${this.$baseNewUrl}esaleb-service-tbs/reduced-fee/exportall?accessToken=${this.$accessToken()}&date=20990101`;
          window.open(url, '_blank');
          this.closeDialog()
        } catch (e) {
          console.log(e)
        }
      },
      // 文件上传成功时的钩子
      handleUploadSuccess(res, file) {
      },
      beforeUpload(file) {
        console.log(file)
        // const isXls = file.type === 'application/vnd.ms-excel';
        // const isXlsx = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const isLt2M = file.size / 1024 / 1024 < 2;

        // if (!isXls && !isXlsx) {
        //   this.$message.error('只能上传xls/xlsx文件!');
        // }
        if (!isLt2M) {
          this.$message.error('文件大小不能超过 2MB!');
        }
        // const check = isLt2M && (isXls || isXlsx);
        const check = isLt2M ;
        return check;
      },
      // 文件上传失败时的钩子
      handleUploadError(res, file) {
        this.$message.error('文件上传失败！')
        this.$alert('文件上传失败！', '上传失败提示', {
          confirmButtonText: '确定',
          type: 'error',
          showClose: false,
          dangerouslyUseHTMLString: true
        })
      },
      // 关闭弹窗
      closeDialog() {
          this.resetData()
      },
      // 话费导入(上传文件)
      onUpload (uploadObj) {
          let file = uploadObj.file
          this.uploadFile = file
          let param = new FormData()
          param.append('file', file)
          

          importAccountStatement(param).then(resp => {
              if (resp && resp.code != 0) {
                  this.$message.error(resp.msg)
                  return
              }
              this.$message.success('对账单导入成功')
              this.closeDialog()
              this.loadList()
              console.log('行吗++++++');
              // console.log('参数params',resp);
              console.log('this.tableData+++',this.tableData);
              for(var i = 0; i < this.tableData.length; i++) {
                var line = this.tableData[i]
                this.getHotSellStatus = line.hotSellStatus.text
                
                // console.log('核销状态',this.getHotSellStatus);
                // if(this.getHotSellStatus == '异常'){
                //   this.errData.push(line)
                //   console.log('this.errData++++',this.errData);
                //   this.$confirm('多出'+this.errData.length+'条异常数据，请下载账单重新核对后重新尝试', '提示', {
                //     cancelButtonText: '取消',
                //     confirmButtonText: '下载账单',
                //   }).then(() => {
                //     this.tableExport();
                //   }).catch(() => {
                //     this.errData = []
                //     this.$message({
                //       type: 'info',
                //       message: '已取消'
                //     });
                //   });
                // }
                // if(this.getHotSellStatus == '异常'){
                //   // this.$confirm('多出异常数据'+ this.tableData.length +'条，请下载账单重新核对后重新尝试', '提示', {
                //   this.$confirm('多出异常数据，请下载账单重新核对后重新尝试', '提示', {
                //     cancelButtonText: '取消',
                //     confirmButtonText: '下载账单',
                //   }).then(() => {
                //     this.tableExport();
                //   }).catch(() => {
                //     this.$message({
                //       type: 'info',
                //       message: '已取消'
                //     });
                //   });
                // }
              }
              
              
              // console.log('this.tableData+++',this.tableData);
              
          }).catch(err => {
              console.log(err)
          })
      },
      //导入支付账单
      onUpload1(uploadObj) {
          let file = uploadObj.file
          let param = new FormData()
          param.append('file', file)
          // console.log('uploadObj', uploadObj)

          uploadPaymentForm(param).then(resp => {
              if (resp && resp.code != 0) {
                  this.$message.error(resp.msg)
                  return
              }
              this.$message.success('支付单导入成功')
              this.closeDialog()
              this.loadList()
          }).catch(err => {
              console.log(err)
          })
      },
      formatDefault: function (date) {
        return formatDate(date, 'yyyyMMdd');
      },

      getFilterData() {
        this.filterData = [
          {month: '5月', day: '25', dayOfTheWeek: '星期一', showIcon: '0'},
          {month: '5月', day: '24', dayOfTheWeek: '星期日', showIcon: '1'},
          {month: '5月', day: '23', dayOfTheWeek: '星期六', showIcon: '0'},
          {month: '5月', day: '22', dayOfTheWeek: '星期五', showIcon: '0'},
          {month: '5月', day: '21', dayOfTheWeek: '星期四', showIcon: '0'},
          {month: '5月', day: '20', dayOfTheWeek: '星期三', showIcon: '0'},
          {month: '5月', day: '19', dayOfTheWeek: '星期二', showIcon: '0'},
          {month: '5月', day: '18', dayOfTheWeek: '星期一', showIcon: '1'},
          {month: '5月', day: '17', dayOfTheWeek: '星期日', showIcon: '0'},
          {month: '5月', day: '16', dayOfTheWeek: '星期六', showIcon: '0'},
          {month: '5月', day: '15', dayOfTheWeek: '星期五', showIcon: '0'},
          {month: '5月', day: '14', dayOfTheWeek: '星期四', showIcon: '0'},
          {month: '5月', day: '13', dayOfTheWeek: '星期三', showIcon: '0'},
          {month: '5月', day: '12', dayOfTheWeek: '星期二', showIcon: '0'},
          {month: '5月', day: '11', dayOfTheWeek: '星期一', showIcon: '0'},
          {month: '5月', day: '10', dayOfTheWeek: '星期日', showIcon: '0'},
        ]
      },

      async getStat() {
        const {data} = await getStatAPI(this.searchForm.params)
        this.stat = data
      },

      // 获取表格数据
      async loadList() {
        const {data} = await getListAPI(this.searchForm)
        this.tableData = data.records
        this.total = data.total
        if(this.tableData != '' && this.tableData.length > 0) {
            console.log('数据表',this.tableData);
            const hostSellStatus = this.tableData[0].hotSellStatus;
             console.log('打印++++',this.hostSellStatus);
            if(hostSellStatus != undefined) {
              this.errhotSellStatus = hostSellStatus.text;
            }
            
        }
        
        
        // for(var i = 0; i < this.tableData.length; i++) {
        //         var line = this.tableData[i]
        //         this.getHotSellStatus = line.hotSellStatus.text
        // }
      },


      // 列表过滤查询
      handleSearch() {
        this.loadList()
        this.getStat()
      },
      // 搜索重置（清空）
      handleReset() {
        // 初始化参数
        // this.searchForm.date = getCurrDay();
        this.dateValue=new Date();
        this.searchForm = this.initSearchParams()
        // 获取表格数据
        this.handleSearch()
      },
      // 列表每页条数变了
      handleSizeChange(val) {
        this.searchForm.size = val
        this.loadList()
      },
      // 列表当前页码变了
      handleCurrentChange(val) {
        this.searchForm.current = val
        this.loadList()
      },


      // 跳转到详情页
      goDetailPage(scope) {
        this.$router.push({
          path: '/tbs/fundManage/reducedFeeDetail',
          query: {
            orderId: scope.row.orderId
          }
        })
      },
      async addMenu() {
        this.postForm.pid = this.selectedRow.id
        try {
          const result = await addMenuAPI(this.postForm)
          this.$message.success('添加菜单成功')
          this.closeDialog()
          this.loadMposData()
        } catch (e) {
          console.log(e)
        }
      },

      async editMenu() {
        this.postForm.pid = this.selectedRow.id
        try {
          const result = await updateMenuAPI(this.postForm)
          this.$message.success('修改菜单成功')
          this.closeDialog()
          this.loadMposData()
        } catch (e) {
          console.log(e)
        }
      }

    }
  }
</script>

<style lang="scss" scoped>
  .greenT {
    color: #2DBAA5 !important;
  }

  .lightGT {
    color: #76C819 !important;
  }

  .orangeT {
    color: #FA6241 !important;
  }

  .grayT {
    color: #B7B2AF !important;
  }

  .blueT {
    color: #3289FF !important;
  }


  // .pageWarp {
  //   height: calc(100vh - 88px);
  // }

  // 黄色提示栏
  .pageWarp .yellow_tips_box {
    margin-top: 0px;
    width: 100%;
    min-height: 28px;
    padding: 6px 9px 6px 12px;
    background: #FFFAEB;
    border: 1px solid #FFC400;
    transition: all 0.3s ease;
  }

  .pageWarp .yellow_tips_box.hide {
    display: none;
    transition: all 0.3s ease;
  }

  .yellow_tips_box .info {
    width: calc(100% - 9.71px - 5px);
    line-height: 16px;
    color: #FFC400;
    font-size: 12px;
    margin-right: 5px;
  }

  .yellow_tips_box .icon_close_yellow {
    width: 9.71px;
    height: 9.71px;
  }


  // 日期、月份筛选区
  .pageWarp .filter_box {
    margin: 5px 0;
    width: 100%;
    height: 124px;
    padding: 30px 0;
    box-sizing: border-box;
    background: #ffffff;
  }

  .filter_box .left_picker {
    width: 205px;
    height: 100%;
    padding: 0 20px 0 12px;
    box-sizing: border-box;
    background: #ffffff;
    border-right: 1px solid #F8F8F8;
  }

  .filter_box ul.right_scroll {
    width: calc(100% - 205px);
    height: 100%;
    padding: 0 12px 0 16px;
    box-sizing: border-box;
    background: #ffffff;
  }

  .filter_box ul.right_scroll li {
    min-width: 46px;
    height: 100%;
    background: #bfd8f8;
  }

  .filter_box ul.right_scroll li:first-child {
    margin-left: 16px;
  }

  .filter_box ul.right_scroll li + li {
    margin-left: 40px;
  }

  .filter_box ul.right_scroll li .top {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 16px;
    color: #7F7F7F;
  }

  .filter_box ul.right_scroll li .circle_box {
    width: 46px;
    height: 46px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    border-radius: 50%;
    position: relative;
    background: #ffffff;
    color: #C5C5C5;
  }

  .filter_box ul.right_scroll li .circle_box.greenBg {
    background: #2DBAA5;
    color: #ffffff;
  }

  .filter_box ul.right_scroll li .circle_box.grayBg {
    background: #FAFAFA;
    color: #333333;
  }

  .filter_box ul.right_scroll li .circle_box .mainT {
    font-size: 20px;
  }

  .filter_box ul.right_scroll li .circle_box .botT {
    font-size: 10px;
    margin-top: 0px;
  }

  .filter_box ul.right_scroll li .warnIcon {
    position: absolute;
    right: 0;
    bottom: 0;

    width: 16px;
    height: 16px;
    background: url('../../../../assets/images/enjoy/redWarnCircleIcon.png') no-repeat;
    background-size: 100% 100%;
  }


  // 筛选框
  .pageWarp .searchBox {
    margin-top: 0px;
  }


  // 总结
  .pageWarp .summary_area {
    flex-wrap: wrap;
  }

  .pageWarp .summary_block {
    margin-top: 12px;
    width: 207px;
    height: 72px;
    background: #fff;
    // border-radius: 5px;
    box-sizing: border-box;
    padding: 12px 20px;
    font-size: 12px;
    color: #333333;
    white-space: nowrap;
    margin-right: 14px;
  }

  .pageWarp .summary_block .first_text {
    min-width: 160px;
    max-width: 100%;
    margin-bottom: 6px;
  }

  .pageWarp .summary_block .first_text small {
    color: #2DBAA5;
    margin-right: 3px;
  }

  .pageWarp .summary_block .second_text {
    // line-height: 16px;
    height: 20px;
  }

  .pageWarp .summary_block .second_text span.bigT {
    height: 20px;
    color: #FA6241;
    font-size: 20px;
    font-weight: normal;
    margin-right: 3px;
  }

  // 左边统计
  .pageWarp .summary_area .summary_block.left_simple_block {
    width: 141px;
    height: 72px;
    background: #fff;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 12px 0px;
    font-size: 12px;
    color: #333333;
    white-space: nowrap;
    margin-right: 14px;
  }


  // 表格
  .pageWarp .botTable {
    margin-top: 12px;
    width: 100%;
    // max-height: 408px;
  }

  .botTable .tableTop {
    height: 54px;
    padding: 0 12px;
    // display: flex;
    // flex-flow: row wrap;
    // justify-content: space-between;
    // align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
    position: relative;
    line-height: 54px;
  }

  .botTable .tableTop .top_le {
    font-size: 15px;
    font-weight: bold;
    color: #4E4A46;
  }

  .botTable .tableTop .exportBtn {
    padding: 5px 12px;
    /*width: 72px;*/
    height: 30px;
    /*line-height: 30px;*/
    font-size: 13px;
    border-radius: 4px;
    position: relative;
    right: 0;
    top: 0;
    width: inherit;
    line-height: 0;

    &:hover {
      background-color: rgba(45, 186, 165, 0.5)
    }
  }
  .btnGroup{
    position:absolute;
    right: 22px;
    top: 0;
  }
  .botTable .tableTop .exportBtn1 {
    &:hover {
      background-color: rgba(245, 245, 245, 1)
    }
  }
  .botTable .tableTop .exportBtn .exportIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn1.png') no-repeat;
    background-size: 14px 14px;
  }
  .botTable .tableTop .exportBtn2 .exportIcon{
    background: url('../../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn2.png') no-repeat;
    background-size: 14px 14px;
  }
  .botTable .tableTop .exportBtn3 .exportIcon{
    background: url('../../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn1.png') no-repeat;
    background-size: 14px 14px;
  }
  .botTable .tableTop .exportBtn > span{
    font-size: 13px;
  }
  /* 分页条 */
  .pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
  }

  // 弹窗按钮-取消按钮
  .cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
  }

  // 弹窗按钮-橙色按钮
  .refuseOBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #FA6241;
    color: #FFFFFF;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

//1215新增
  .package-top{
    position: absolute;
    top: 5px;
    width: 100%;
    text-align: right
  }
  .package-top .butStyle{
    padding: 7px 10px;
    margin-right: 12px;
    font-size: 13px;
    background: #FA6241;
    position: relative;
    right: 0;
    top: 0;
    width: inherit;
    height: inherit;
    line-height: inherit;
    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }
  .package-top .butStyle>span{
    font-size: 13px;
  }
  .package-top .butStyle > i{
    font-size: 15px;
  }
  .package-top .exportBtn .exportIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
    background-size: 14px 14px;
  }
  .exportBtn1{
    background: #F5F5F5;
    color: #D1D1D1;
    margin-right: 20px;
  }
  .exportBtn2{
    background: #2DBAA5;
    color: #FFFFFF;
  }
  .exportBtn3{
    background: #F5F5F5;
    color: #D1D1D1;
    margin-right: 20px; 
  }
  .botTable .tableTop .exportBtn2 {
    &:hover {
      background-color: rgba(45, 186, 165, 0.5)
    }
  }
  .botTable .tableTop .exportBtn3 {
    &:hover {
      background-color: rgba(245, 245, 245, 1)
    }
  }
  // 弹窗按钮-取消按钮
.cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
}

// 弹窗按钮-橙色按钮
.refuseOBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    color: #FFFFFF;
    // background: #FA6241;
    // &:hover {
    //   background-color: rgb(247, 143, 120);
    // }
    background: #2DBAA5;
    &:hover {
      background-color: rgb(117, 189, 178);
    }
}


.uploadBtn {
    font-size: 12px;
    color: #ffffff;
    border: none;
    background: #2DBAA5;
    &:hover {
      background-color: rgb(117, 189, 178);
    }
}
.uploadTip {
//   display: inline;
    font-size: 12px;
    color: #AAAAAA;
    margin-left: 12px;
}
.uploadTemplate {
    display: inline;
    cursor: pointer;
    font-size: 12px;
    color: #2DBAA5;
    text-decoration: none;
}
.uploadTemplate :active {
    color: rgb(134, 189, 180);
}
</style>

